/* global DetailsDisclosure, trapFocus, removeTrapFocus */

if (!customElements.get('aur-sacola-gofi-revelo')) {
  class CartSummaryDisclosure extends DetailsDisclosure {
    constructor() {
      super();
      this.openBtn = this.querySelector('summary');
      this.closeBtn = this.querySelector('.aur-bo-encerrar');
      this.overlay = document.querySelector('.aur-veu--sacola-musu');
      this.drawerCloseHandler = this.handleDrawerClose.bind(this);
    }

    connectedCallback() {
      document.addEventListener('on:aur-sacola-gaveta:before-close', this.drawerCloseHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('on:aur-sacola-gaveta:before-close', this.drawerCloseHandler);
    }

    /**
     * Handles 'click' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.aur-bo-encerrar')) return;
      this.close();
    }

    /**
     * Handles 'on:aur-sacola-gaveta:before-close' events.
     */
    handleDrawerClose() {
      if (this.disclosure.open) {
        this.close();
      }
    }

    /**
     * Opens the details element.
     */
    open() {
      super.open();

      if (this.closest('.aur-sacola-musu--puno')) return;

      this.overlay.classList.add('aur-bi-exposto');
      trapFocus(this);

      // Create event handler variables (so the bound event listeners can be removed).
      this.clickHandler = this.clickHandler || this.handleClick.bind(this);
      this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();

      // Add event listeners (for while disclosure is open).
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.overlay.addEventListener('click', this.clickHandler);
    }

    /**
     * Closes the details element.
     */
    close() {
      this.overlay.classList.remove('aur-bi-exposto');
      super.close();
      removeTrapFocus(this.openBtn);

      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keyup', this.keyupHandler);
      this.overlay.removeEventListener('click', this.clickHandler);
    }
  }

  customElements.define('aur-sacola-gofi-revelo', CartSummaryDisclosure);
}
